import { TargetTooltipPopoverStyle } from './Slider.styles';
import { Popover } from 'antd';

import { SliderPoint } from '@/comp/StationControlCenter/ControlCenterCompressorWidget/DetailsWidgetSlider/DetailsWidgetSlider.types';

import { Point } from './Slider.styles';

export const renderPoints = (points: SliderPoint[], adjustedMin: number, adjustedMax: number, addSideGaps: boolean) => {
  const renderedValues = new Map();
  const labelOffsets = new Map();
  return points.map(point => {
    if (point.value == null || isNaN(point.value) || (point.isTarget && point.value < adjustedMin)) return null;

    const existingPoint = renderedValues.get(point.value);
    const offset = labelOffsets.get(point.value) || 0;
    renderedValues.set(point.value, (existingPoint || 0) + 1);
    labelOffsets.set(point.value, offset + 1);
    const isSubsequentPoint = existingPoint !== undefined;

    return (
      <Point
        key={`${point.value}-${point.label}`}
        $value={point.value}
        $highlighted={point.highlighted}
        $min={adjustedMin}
        $max={adjustedMax}
        $addSideGaps={addSideGaps}
      >
        {point.isTarget ? (
          <Popover placement="bottom" content={point.value} overlayClassName="target-tooltip">
            <TargetTooltipPopoverStyle />
            <div className="target" />
          </Popover>
        ) : isSubsequentPoint ? (
          <div className="subsequent-label" style={{ top: `${offset * 26}px` }}>
            <div className="label">{point.label}</div>
          </div>
        ) : (
          <>
            <div className="pipe" />
            <div>
              <div className="point-value">{point.value}</div>
              <div className="point-label">{point.label}</div>
            </div>
          </>
        )}
      </Point>
    );
  });
};

export const getAdjustedMin = (min: number, max: number) =>
  !isNaN(min) && min != null ? min : max != null ? max * 0.9 : null;

export const getAdjustedMax = (min: number, max: number) =>
  !isNaN(max) && max != null ? max : min != null ? min * 1.1 : null;
